"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SubmenuLightThemeBg = ({
  bgColor
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 1190 203",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "submenutlightbg-path-1",
        x: "0",
        y: "0",
        width: "1190",
        height: "203"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
            fill: bgColor,
            xlinkHref: "#submenutlightbg-path-1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
            fillOpacity: "0.65",
            fill: "#FFFFFF",
            xlinkHref: "#submenutlightbg-path-1"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M0,-7.10542736e-15 L1190,-7.10542736e-15 L1190,88.8453479 C1120.50089,91.9625955 1033.23979,87.7081866 928.216686,76.0821213 C770.682033,58.6430234 508.737167,17.7258334 345,22.3521602 C246.122292,25.1459094 131.122292,33.1523167 0,46.371382 L0,-7.10542736e-15 Z",
          fillOpacity: "0.2",
          fill: "#FFFFFF"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M0,-7.10542736e-15 L1190,-7.10542736e-15 L1190,88.8453479 C1120.50089,91.9625955 1033.23979,87.7081866 928.216686,76.0821213 C770.682033,58.6430234 508.737167,17.7258334 345,22.3521602 C246.122292,25.1459094 131.122292,33.1523167 0,46.371382 L0,-7.10542736e-15 Z",
          fillOpacity: "0.2",
          fill: "#FFFFFF",
          transform: "translate(595.000000, 44.916995) scale(-1, 1) translate(-595.000000, -44.916995) "
        })]
      })
    })]
  });
};
var _default = exports.default = SubmenuLightThemeBg;